// extracted by mini-css-extract-plugin
export var container = "_67-0";
export var error = "_67-9";
export var label = "_67-5";
export var light = "_67-6";
export var md = "_67-3";
export var sm = "_67-2";
export var thin = "_67-8";
export var thinBold = "_67-7";
export var vertical = "_67-4";
export var xs = "_67-1";